import store from '../../store/index.js';
import { ANSWER, ANSWER_MEMBER } from '../../store/mutation-types.js';

import QuestionGender from '../../components/question-gender/QuestionGender.vue';
import QuestionName from '../../components/question-name/QuestionName.vue';
import QuestionMember from '../../components/question-member/QuestionMember.vue';
import QuestionAge from '../../components/question-age/QuestionAge.vue';
import QuestionIncome from '../../components/question-income/QuestionIncome.vue';
import QuestionAddress from '../../components/question-address/QuestionAddress.vue';
const QUESTIONES = [
    {
        component: QuestionGender,
        props() {
            return {
                updateAnswer(answer) {
                    store.commit(ANSWER, {
                        idx: 'gender',
                        value: answer,
                    });
                },
                gender: store.state.answer.gender,
            };
        },
    },
    {
        component: QuestionName,
        props() {
            const { gender, name } = store.state.answer;

            return {
                updateAnswer(answer) {
                    store.commit(ANSWER, {
                        idx: 'name',
                        value: answer,
                    });
                },
                gender,
                name,
            };
        },
    },
    {
        component: QuestionMember,
        props() {
            const { gender, member } = store.state.answer;
            return {
                updateAnswer(type, answer, index) {
                    store.commit(ANSWER_MEMBER, {
                        type,
                        index,
                        idx: 'checked',
                        value: answer,
                    });
                },
                gender,
                member,
            };
        },
    },
    {
        component: QuestionAge,
        props() {
            return {
                updateAnswer(index, answer) {
                    store.commit(ANSWER_MEMBER, {
                        type: 'update',
                        index,
                        idx: 'age',
                        value: answer,
                    });
                },
                member: store.state.answer.member,
            };
        },
    },
    {
        component: QuestionIncome,
        props() {
            const { member } = store.state.answer;
            return {
                updateAnswer(index, answer) {
                    store.commit(ANSWER_MEMBER, {
                        type: 'update',
                        index,
                        idx: 'income',
                        value: answer,
                    });
                },
                member,
            };
        },
    },
    {
        component: QuestionAddress,
        props() {
            return {
                updateAnswer(answer, idx) {
                    store.commit(ANSWER, {
                        idx,
                        value: answer,
                    });
                },
                city: store.state.answer.city,
                cityCode: store.state.answer.cityCode,
            };
        },
    },
];

export { QUESTIONES }